/**
 * Pacific wall-clock stamps for evidence. Doom's packets cite Pacific time ("Time PT"), and a screenshot is only
 * evidence when it carries one (Baseline 10-20 E2: "clock absent", time "Not visible").
 */
const TIME = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });
const DATE = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit' });

/** "19:42:05 PT" (some engines print midnight as 24:…). */
export function ptClock(ms: number): string {
  return `${TIME.format(ms).replace(/^24:/, '00:')} PT`;
}

/** "2026-10-20", the Pacific calendar date. */
export function ptDate(ms: number): string {
  return DATE.format(ms);
}

/** `iso` ± days on the calendar ("2026-10-20", −1 → "2026-10-19"); LA dates are labels here, no zone arithmetic. */
export function shiftPtDate(iso: string, days: number): string {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(Date.UTC(y!, m! - 1, d! + days)).toISOString().slice(0, 10);
}
